 const shopActionTypes={
  // UPDATE_COLLECTIONS:'UPDATE_COLLECTIONS'
  FETCH_COLLECTIONS_START:'FETCH_COLLECTIONS_START',
  FETCH_COLLECTIONS_SUCCESS:'FETCH_COLLECTIONS_SUCCESS',
  FETCH_COLLECTIONS_FAILURE:'FETCH_COLLCETIONS_FAILURE'


}
export default shopActionTypes